import React, { FC } from 'react';
import { Column, Grid } from '@goldbely/explore-component-library';

import { Routes } from 'src/explore/services/Routes';

import { Product } from './elements/Product';

import styles from './index.module.sass';

type IProductProps = {
  hideProduct?: 'the-classics-kit' | 'large-hosting-kit' | 'limited-edition-azalea-kit';
  hideDescriptions?: boolean;
  comingSoon?: boolean;
  soldOutProducts?: number[];
};

export const Products: FC<IProductProps> = ({
  hideDescriptions = false,
  hideProduct,
  comingSoon,
  soldOutProducts = [],
}) => {
  const images = {
    'large-hosting-kit': comingSoon ? Routes.image.consumer( 'wl/tasteofthemasters/large-hosting-kit-2025.jpg' ) : Routes.image.uploads( 'showcase_media_asset/image/264630/TOTM_1x1_8.jpg' ),
    'the-classics-kit': comingSoon ? Routes.image.consumer( 'wl/tasteofthemasters/classics-hosting-kit-2025.jpg' ) : Routes.image.uploads( 'showcase_media_asset/image/264621/TOTM_1x1_6.jpg' ),
    'limited-edition-azalea-kit': comingSoon ? Routes.image.consumer( 'wl/tasteofthemasters/azalea-cocktail-kit-2025.jpg' ) : Routes.image.uploads( 'showcase_media_asset/image/265528/AzaleaImage1.jpg' ),
  }

  const azaleaKit2025 = 'Exclusive to Taste of the Masters, enjoy our new non-alcoholic Azalea cocktail mix with cups and tools to mix up the signature cocktail of the Tournament.';
  const azaleaKit2026 = "Back by popular demand, enjoy our non-alcoholic Azalea mix with Masters cups and custom tools to craft the Tournament's signature cocktail.";
  const descriptions = {
    'large-hosting-kit': `Recreate the patron experience as you celebrate the ${comingSoon ? '2025' : '2026'} Masters with our signature pimento cheese, egg salad, pork bar-b-que and classic concessions.`,
    'the-classics-kit': 'Perfect for smaller groups who want to enjoy an iconic Masters meal with our signature pimento cheese and classic concessions.',
    'limited-edition-azalea-kit': comingSoon ? azaleaKit2025 : azaleaKit2026,
  }

  const span = hideProduct ? { lg: 3 } : { lg: 4 }

  return (
    <Grid className={styles.grid}>
      {hideProduct !== 'large-hosting-kit' && (
        <Column span={span}>
          <Product
            id={47988}
            title="Large Hosting Kit"
            comingSoon={comingSoon}
            description={descriptions['large-hosting-kit']}
            src={images['large-hosting-kit']}
            href="/large-hosting-kit"
            hideDescription={hideDescriptions}
            soldOut={soldOutProducts.includes( 47988 )}
          />
        </Column>
      )}
      {hideProduct !== 'the-classics-kit' && (
        <Column span={span}>
          <Product
            id={47992}
            title="The Classics Kit"
            comingSoon={comingSoon}
            description={descriptions['the-classics-kit']}
            src={images['the-classics-kit']}
            href="/the-classics-kit"
            hideDescription={hideDescriptions}
            soldOut={soldOutProducts.includes( 47992 )}
          />
        </Column>
      )}
      {hideProduct !== 'limited-edition-azalea-kit' && (
        <Column span={span}>
          <Product
            id={50454}
            title={comingSoon ? "New Azalea Kit" : "Azalea Cocktail Kit"}
            comingSoon={comingSoon}
            description={descriptions['limited-edition-azalea-kit']}
            src={images['limited-edition-azalea-kit']}
            href="/limited-edition-azalea-kit"
            hideDescription={hideDescriptions}
            soldOut={soldOutProducts.includes( 50454 )}
          />
        </Column>
      )}
    </Grid>
  );
}
